module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workReport"
  }, [(_vm.item.attr === 'approvedPeople') ? [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.item.attrValue),
      callback: function($$v) {
        _vm.$set(_vm.item, "attrValue", $$v)
      },
      expression: "item.attrValue"
    }
  })] : (_vm.item.attr === 'cc') ? [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择抄送人",
      "multiple-limit": 20,
      "size": "small"
    },
    model: {
      value: (_vm.item.attrValue),
      callback: function($$v) {
        _vm.$set(_vm.item, "attrValue", $$v)
      },
      expression: "item.attrValue"
    }
  }, _vm._l((_vm.mUserList), function(user) {
    return _c('el-option', {
      key: user.userId,
      attrs: {
        "label": user.name,
        "value": user.userId
      }
    })
  }))] : (_vm.item.attr === 'thisPlan') ? [(_vm.item.attrValue.length === 0) ? _c('div', [_vm._v("\n      无\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.formatStatus(_vm.item.attrValue)), function(plan) {
    return _c('div', {
      staticClass: "todayPlan"
    }, [_c('el-switch', {
      attrs: {
        "active-color": "#13ce66",
        "inactive-color": "#ff4949",
        "active-text": "已完",
        "inactive-text": "未完"
      },
      model: {
        value: (plan.status),
        callback: function($$v) {
          _vm.$set(plan, "status", $$v)
        },
        expression: "plan.status"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text",
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_vm._v(_vm._s(plan.content))])], 1)
  })] : _vm._e(), _vm._v(" "), (_vm.item.attr === 'thisStatistic') ? [_c('div', {
    staticClass: "workData"
  }, [_vm._v("\n      " + _vm._s(_vm.formatStatistic(_vm.item.attrValue)) + "\n    ")])] : _vm._e(), _vm._v(" "), (_vm.item.attr === 'nextPlan') ? _vm._l((_vm.formatNextPlan(_vm.item.attrValue)), function(plan, index) {
    return _c('el-input', {
      key: index,
      staticClass: "v-input",
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "placeholder": "请输入计划"
      },
      model: {
        value: (plan.content),
        callback: function($$v) {
          _vm.$set(plan, "content", $$v)
        },
        expression: "plan.content"
      }
    }, [(index === 0) ? _c('el-button', {
      attrs: {
        "slot": "append",
        "icon": "el-icon-plus"
      },
      on: {
        "click": function($event) {
          _vm.addTel(_vm.item.attrValue)
        }
      },
      slot: "append"
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('el-button', {
      attrs: {
        "slot": "append",
        "icon": "el-icon-minus"
      },
      on: {
        "click": function($event) {
          _vm.delTel(index, _vm.item.attrValue)
        }
      },
      slot: "append"
    }) : _vm._e()], 1)
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2616db22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fieldtype/work-report/index.vue
// module id = 1238
// module chunks = 82